<template>
  <div class="PuriSheet" @click="$emit('click')">
    <div class="card">
      <div v-if="membershipGrade === 1" class="header">保存期間 残り{{ limitDateStr }}日</div>
      <div class="body">
        <puri-contents-gimmi
          v-if="puriList.length > 9"
          :uris="uris"
          :selects="selects"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
        <puri-contents4
          v-else-if="puriList.length === 4"
          :uris="uris"
          :selects="selects"
          :arcadeName="arcadeName"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
        <puri-contents5
          v-else-if="puriList.length === 5"
          :uris="uris"
          :selects="selects"
          :arcadeName="arcadeName"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
        <puri-contents6
          v-else-if="puriList.length === 6"
          :uris="uris"
          :selects="selects"
          :arcadeName="arcadeName"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
        <puri-contents7
          v-else-if="puriList.length === 7"
          :uris="uris"
          :selects="selects"
          :arcadeName="arcadeName"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
        <puri-contents8
          v-else-if="puriList.length === 8"
          :uris="uris"
          :selects="selects"
          :arcadeName="arcadeName"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
        <puri-contents9
          v-else-if="puriList.length === 9"
          :uris="uris"
          :selects="selects"
          :arcadeName="arcadeName"
          :hasgraffs="hasgraffs"
          :surpriseShots="surpriseShots"
          :surpriseShot2s="surpriseShot2s"/>
      </div>
      <div
        class="footer"
        :style="'background-image: url(' + getImg(arcadeLogoImg) + ')'">{{ createDateStr }}</div>
    </div>
  </div>
</template>

<script>
import PuriContents4 from "./PuriContents4";
import PuriContents5 from "./PuriContents5";
import PuriContents6 from "./PuriContents6";
import PuriContents7 from "./PuriContents7";
import PuriContents8 from "./PuriContents8";
import PuriContents9 from "./PuriContents9";
import PuriContentsGimmi from "./PuriContentsGimmi";
import Protobuf from '../mixins/protobuf'
import { daysLeft, toJpegURI, ymd } from "../assets/js/util";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const pbc = require('../assets/js/kumaproto').kuma.jp.protobuf.common

export default {
  components: {
    PuriContents4,
    PuriContents5,
    PuriContents6,
    PuriContents7,
    PuriContents8,
    PuriContents9,
    PuriContentsGimmi
  },

  mixins: [Protobuf],

  props: {
    limitDate: {
      type: Number,
      required: true
    },
    arcadeName: {
      type: String,
      required: true
    },
    createDate: {
      type: Number,
      required: true
    },
    puriList: {
      type: Array,
      required: true
    },
    arcadeLogoImg: {
      type: String,
      required: true
    },
    membershipGrade: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      contents: [],
      tmpContents: []
    }
  },

  computed: {
    createDateStr() {
      return ymd(this.createDate).join('.')
    },
    limitDateStr() {
      return daysLeft(this.limitDate)
    },
    selects() {
      return this.contents.map(c => c.selected)
    },
    uris() {
      return this.contents.map(c => toJpegURI(c.bytes))
    },
    hasgraffs() {
      return this.contents.map(c => c.hasgraff)
    },
    surpriseShots() {
      return this.contents.map(c => c.surpriseShot)
    },
    surpriseShot2s() {
      return this.contents.map(c => c.surpriseShot2)
    }
  },

  async mounted() {
    this.contents = []
    this.tmpContents = []
    const image = pbc.PuriContentType.THUMBNAIL
    const imageBase = pbc.PuriContentType.THUMBNAIL_BASE
    const decodes = await this.getPuriContentRequests(image, imageBase)

    decodes.forEach((d, i) => {
      let bytes;
      if(this.puriList[i].surpriseShot2){
        // プリもっと2枚目は加工無し画像
        bytes = d.contents[imageBase]
      } else {
        // その他は加工あり画像
        bytes = d.contents[image]
      }
      this.tmpContents.push({
        bytes: bytes,
        selected: this.puriList[i].selected || !this.$store.getters.isFreeMembership,
        seqIndex: this.puriList[i].seqIndex,
        hasgraff: d.hasgraff,
        surpriseShot: this.puriList[i].surpriseShot,
        surpriseShot2: this.puriList[i].surpriseShot2
      })
    })
  },

  watch: {
    tmpContents(v) {
      if (v.length === this.puriList.length) {
        this.contents = v.concat().sort((a, b) => a.seqIndex - b.seqIndex)
      }
    }
  },

   methods: {
    getArcadeName(name) {
      if(name === 'Bépiu.') {
        return 'bepiu'
      } else {
        return name
      }
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
    async getPuriContentRequests(image, imageBase){
      const requests = []
      const cmdNo = pb.PuriContentReq.CommandNo.COMMAND_NO

      this.puriList.forEach(d => {
        let types;
        if(d.surpriseShot2){
          types = imageBase
        } else {
          types = image
        }
        const message = pb.PuriContentReq.create({
          id: d.id,
          types: [types]
        })
        const encoded = pb.PuriContentReq.encode(message).finish()
        requests.push(
          this.post(cmdNo, encoded).catch(() => {
            this.$_error('Error', { title: 'クーポン', statusCode: 100 })
          })
        )
      })
      // 並列処理で高速化するため
      const decodes = await Promise.all(requests)
      return decodes
      }
   }
}
</script>

<style lang="scss" scoped>
.card {
  background-color: #fff;
  border-radius: 8px;
  margin: 30px 15px 0;
  padding: 10px 20px;
  border: 1px solid #E1DADB;
}
.header {
  padding-left: 40px;
  font-size: 12px;
  color: #F63C5B;
  background-image: url(../assets/Png/Common/ic_exclamation_pink.png);
  background-size: contain;
  background-position: 10px;
}
.body {
  margin: 10px 0;
}
.footer {
  padding: 2px 0;
  text-align: right;
  font-size: 10px;
  color: #373737;
  background-size: contain;
  background-position: 77%;
  &.romakyun      { background-image: url(../assets/Png/Common/pridl_logo_small_romakyun.png); }
  &.bepiu         { background-image: url(../assets/Png/Common/PriDl_logo_small_Bepiu.png); }
  &.ROMAPI        { background-image: url(../assets/Png/Common/pridl_logo_small_romapi.png); }
  &.lalamee       { background-image: url(../assets/Png/Common/Pridl_logo_small_lalamee.png); }
  &.meityromantic { background-image: url(../assets/Png/Common/image_logo_meiroma_black_small.png); }
  &.fiz2          { background-image: url(../assets/Png/Common/image_logo_fiz2_black_small.png); }
  &.fiz           { background-image: url(../assets/Png/Common/image_logo_fiz_black_small.png); }
}
</style>
